export default {
  methods: {
    displayMessage(message) {
      this.$store.commit('messages/add', message);
    },
  },
};
